import Link from '@jetbrains/ring-ui/components/link/link'
import type {MarkdownProps as RingMarkdownProps} from '@jetbrains/ring-ui/components/markdown/markdown'
import RingMarkdown from '@jetbrains/ring-ui/components/markdown/markdown'
import classNames from 'classnames'
import React from 'react'

import {resolveRelative} from '../../../utils/url'

import styles from './Markdown.css'

export enum LinkOpenPolicy {
  ALL_IN_NEW_TAB = 'ALL_IN_NEW_TAB',
  EXTERNAL_IN_NEW_TAB = 'EXTERNAL_IN_NEW_TAB',
  NONE = 'NONE',
}

function isRelativeUrl(url: string | undefined) {
  return url?.startsWith('/')
}

function getLinkOpenPolicy(policy: LinkOpenPolicy, url: string | undefined) {
  if (policy === LinkOpenPolicy.EXTERNAL_IN_NEW_TAB) {
    return isRelativeUrl(url) ? {} : {target: '_blank', rel: 'noreferrer'}
  }

  if (policy === LinkOpenPolicy.ALL_IN_NEW_TAB) {
    return {target: '_blank', rel: 'noreferrer'}
  }

  return {}
}

interface ComponentsProps {
  linkOpenPolicy?: LinkOpenPolicy
}

export type MarkdownProps = RingMarkdownProps &
  ComponentsProps & {
    children: string
  }

const getCustomMarkdownComponents = ({
  linkOpenPolicy = LinkOpenPolicy.EXTERNAL_IN_NEW_TAB,
}: ComponentsProps) =>
  ({
    a: ({node, href, ...props}) => (
      <Link
        {...props}
        {...getLinkOpenPolicy(linkOpenPolicy, href)}
        href={href && isRelativeUrl(href) ? resolveRelative(href) : href}
      />
    ),
  }) as RingMarkdownProps['components']

export default function Markdown({
  children,
  linkOpenPolicy,
  className,
  ...restProps
}: MarkdownProps) {
  return (
    <RingMarkdown
      className={classNames(styles.markdown, className)}
      components={getCustomMarkdownComponents({linkOpenPolicy})}
      {...restProps}
    >
      {children}
    </RingMarkdown>
  )
}
